/**
 * API configuration for Mami Tracker
 *
 * Uses VITE_API_URL environment variable for the backend URL.
 * Falls back to relative paths for same-origin deployments.
 */

export const API_URL = import.meta.env.VITE_API_URL || '';

/**
 * Builds a full API URL from a path
 * @param path - API path starting with / (e.g., '/api/meals')
 * @returns Full URL to the API endpoint
 */
export function apiUrl(path: string): string {
  return `${API_URL}${path}`;
}
